import { createDCHook, collapseDataFromCall } from '../client';
import { getSolutionOverview, featureToggleOverview, getGeneratedSwagger } from '../services/SolutionOverviewService';

export const useSolutionOverviewGetSolutionOverview = createDCHook(
  'getSolutionOverview',
  collapseDataFromCall(getSolutionOverview),
  { injectables: [], flattenData: true },
);

export const useSolutionOverviewFeatureToggleOverview = createDCHook(
  'featureToggleOverview',
  collapseDataFromCall(featureToggleOverview),
  { injectables: [], flattenData: true },
);

export const useSolutionOverviewGetGeneratedSwagger = createDCHook('getGeneratedSwagger', getGeneratedSwagger, {
  injectables: [],
  flattenData: false,
});
